import React from "react";
import Icon, { IconName } from "Components/Icons/Icon";

interface AvatarToggleRowProps {
  label: string;
  icon: IconName;
  name: string;
  value: boolean;
  onToggle: () => void;
}

const AvatarToggleRow: React.FC<AvatarToggleRowProps> = ({
  label,
  icon,
  name,
  value,
  onToggle,
}) => {
  return (
    <div className="d-flex flex-row justify-content-between align-items-center">
      {/* LEFT PART */}
      <div className="d-flex gap-2 align-items-center">
        <div className="avatar-xs flex-shrink-0">
          <span className="avatar-title text-primary bg-light br-8">
            <Icon name={icon} />
          </span>
        </div>

        {/* LABEL */}
        <p className="font-primary fs-16 text-black2D fw-normal m-0">{label}</p>
      </div>

      {/* RIGHT TOGGLE */}
      <div
        className={`toggle-switch ${value ? "on" : "off"}`}
        onClick={onToggle}
        style={{ width: 38 }}
      >
        <div className={`toggle-circle ${value ? "on" : "off"}`} />
      </div>
    </div>
  );
};

export default React.memo(AvatarToggleRow);
